module.exports = "/images/vendor/flag-icon-css/flags/1x1/bt.svg?dbb1623f2a2bcf088f45e7c5a4eee71f";